export default function PageHeader({ titulo, subtitulo, acoes }) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-header__title">{titulo}</h1>
        {subtitulo && <div className="page-header__subtitle">{subtitulo}</div>}
      </div>
      {acoes && <div className="page-header__actions">{acoes}</div>}
    </div>
  );
}
